import { render, staticRenderFns } from "./CoworkersStatusDialog.vue?vue&type=template&id=ab2aaac6&"
import script from "./CoworkersStatusDialog.vue?vue&type=script&lang=js&"
export * from "./CoworkersStatusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports